import React from "react";
import Header from "./Header";
import Hero from "./Hero";

const HeroSection = () => {
  return (
    <div className="bg-gradient-to-b from-Dark1 to-Dark2">
      <Header />
      <Hero />
    </div>
  );
};

export default HeroSection;
